import React from "react";

import { useTranslation } from "react-i18next";

const PrivacyBody = () => {
  const { t } = useTranslation("privacy");
  return (
    <div className="container mx-auto py-12 md:py-24 [&_a]:underline">
      <div className="space-y-5 mb-4 md:mb-16">
        <h3 className="text-center text-3xl lg:text-[56px] lg:leading-[4rem] font-test-sohne-medium">
          {t("privacyHeading")}
        </h3>
      </div>
      <p className="font-test-sohne-semibold text-[14px] mb-3">
        {t("lastUpdated")}
      </p>
      <div className="space-y-5">
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            1. {t("introduction")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("privacyLight1")}
            <br />
            <br />
            <span className="font-test-sohne-medium">Websites:</span>
            <ul className="list-disc text-sm md:text-[15px] text-CharcoalGrey px-4">
              <li>
                <a
                  href="https://smartcomply.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://smartcomply.com
                </a>
              </li>
              <li>
                <a
                  href="https://intel.smartcomply.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://intel.smartcomply.com
                </a>
              </li>
              <li>
                <a
                  href="https://secure.smartcomply.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://secure.smartcomply.com
                </a>
              </li>
              <li>
                <a
                  href="https://adhere.smartcomply.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://adhere.smartcomply.com
                </a>
              </li>
            </ul>
            <br />
            <span className="font-test-sohne-medium">Apps:</span>
            <ul className="list-disc text-sm md:text-[15px] text-CharcoalGrey px-4">
              <li>
                <a
                  href="https://intel.smartcomply.com/login"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://intel.smartcomply.com/login
                </a>
              </li>
              <li>
                <a
                  href="https://app.smartcomply.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://app.smartcomply.com/
                </a>
              </li>
              <li>
                <a
                  href="https://adhere-app.smartcomply.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://adhere-app.smartcomply.com/
                </a>
              </li>
            </ul>
            <br />
            {t("privacyLight5")}
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            2. {t("privacyOverview.overviewBold")}
          </h4>

          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("privacyOverview.overviewLight")}
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            3. {t("whoWeAre.whoWeAreBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("whoWeAre.whoWeAreLight")}
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            4. {t("personalInfo.personalInfoBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("personalInfo.personalInfoLight")}
          </p>
          <ul className="list-disc text-sm md:text-[15px] text-CharcoalGrey px-4">
            <li>{t("personalInfo.name")}</li>
            <li>{t("personalInfo.email")}</li>
            <li>{t("personalInfo.phone")}</li>
            <li>{t("personalInfo.address")}</li>
            <li>{t("personalInfo.billing")}</li>
            <li>{t("personalInfo.demography")}</li>
          </ul>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("personalInfo.personalInfoLight2")}
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            5. {t("cookies.cookiesBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("cookies.cookiesLight1")}
          </p>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("cookies.cookiesLight2")}
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            6. {t("legalBases.legalBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("legalBases.legalLight1")}
          </p>
          <ol className="space-y-1 list-[lower-alpha] list-inside marker:text-sm marker:font-test-sohne-medium text-sm md:text-[15px] text-CharcoalGrey">
            <li className="">
              <span className="font-test-sohne-medium">
                {t("legalBases.legalTitle1")}:{" "}
              </span>
              {t("legalBases.legalLight2")}
            </li>
            <li className="">
              <span className="font-test-sohne-medium">
                {t("legalBases.legalTitle2")}:{" "}
              </span>{" "}
              {t("legalBases.legalLight3")}
            </li>
            <li className="">
              <span className="font-test-sohne-medium">
                {t("legalBases.legalTitle3")}:{" "}
              </span>
              {t("legalBases.legalLight4")}
            </li>
          </ol>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            7. {t("purpose.purposeBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("purpose.purposeLight")}
          </p>
          <div className="border border-[#eee] p-3">
            <div className="w-full flex border-b border-b-[#eee]">
              <div className="w-full">
                <p className="w-full bg-PaleTurquoise px-4 py-3">
                  {t("purpose.purposeTable.tableProcessingBold")}
                </p>
                <ul class="list-disc px-7 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableProcessingLight1")}
                  </li>
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableProcessingLight2")}
                  </li>
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableProcessingLight3")}
                  </li>
                </ul>
              </div>
              <div className="w-full">
                <p className="w-full bg-PaleTurquoise px-4 py-3">
                  {t("purpose.purposeTable.tableLawfulBold")}
                </p>
                <ul class="px-4 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableLawfulLight1")}
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex border-b border-b-[#eee]">
              <div className="w-full">
                <ul class="list-disc px-7 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableProcessingLight4")}
                  </li>
                </ul>
              </div>
              <div className="w-full">
                <ul class="px-4 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableLawfulLight2")}
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex border-b border-b-[#eee]">
              <div className="w-full">
                <ul class="list-disc px-7 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableProcessingLight5")}
                  </li>
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableProcessingLight6")}
                  </li>
                </ul>
              </div>
              <div className="w-full">
                <ul class="px-4 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableLawfulLight3")}
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex border-b border-b-[#eee]">
              <div className="w-full">
                <ul class="list-disc px-7 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableProcessingLight7")}
                  </li>
                </ul>
              </div>
              <div className="w-full">
                <ul class="px-4 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableLawfulLight4")}
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex">
              <div className="w-full">
                <ul class="list-disc px-7 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableProcessingLight8")}
                  </li>
                </ul>
              </div>
              <div className="w-full">
                <ul class="px-4 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableLawfulLight5")}
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex">
              <div className="w-full">
                <ul class="list-disc px-7 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableProcessingLight9")}
                  </li>
                </ul>
              </div>
              <div className="w-full">
                <ul class="px-4 py-2">
                  <li className="text-sm mb-2">
                    {t("purpose.purposeTable.tableLawfulLight2")}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            8. {t("protectionInfo.protectionBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("protectionInfo.protectionLight")}
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            9. {t("disclosure.disclosureBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("disclosure.disclosureLight1")}
          </p>
          <ul className="list-disc px-4 text-sm md:text-[15px] text-CharcoalGrey">
            <li className="mb-2">
              <strong className="font-test-sohne-medium">
                {" "}
                {t("disclosure.disclosureOneStrong")}
              </strong>
              {t("disclosure.disclosureOneText")}
            </li>
            <li className="mb-2">
              <strong className="font-test-sohne-medium">
                {t("disclosure.disclosureTwoStrong")}
              </strong>{" "}
              {t("disclosure.disclosureTwoText")}
            </li>
            <li className="mb-2">
              <strong className="font-test-sohne-medium">
                {t("disclosure.disclosureThreeStrong")}
              </strong>{" "}
              {t("disclosure.disclosureThreeText")}
            </li>
            <li className="mb-2">
              <strong className="font-test-sohne-medium">
                {t("disclosure.disclosureFourStrong")}
              </strong>{" "}
              {t("disclosure.disclosureFourText")}
            </li>
          </ul>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            10. {t("yourRights.rightsBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("yourRights.rightLight1")}
          </p>
          <ul className="list-disc px-4 text-sm md:text-[15px] text-CharcoalGrey">
            <li className="tet mb-2">{t("yourRights.rightLight2")}</li>
            <li className="mb-2">{t("yourRights.rightLight3")}</li>
            <li className="mb-2">{t("yourRights.rightLight4")}</li>
            <li className="mb-2"> {t("yourRights.rightLight5")}</li>
            <li className="mb-2">{t("yourRights.rightLight6")}</li>
          </ul>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("yourRights.rightsLight7")}
          </p>
          <div>
            <p className="text-sm md:text-[15px] text-CharcoalGrey">
              {t("yourRights.rightsLight8")}
            </p>
            <p className="text-sm md:text-[15px] text-CharcoalGrey">
              {t("yourRights.rightsLight9")}
            </p>
            <p className="text-sm md:text-[15px] text-CharcoalGrey">
              David Olajide
            </p>

            <p className="text-sm md:text-[15px] text-CharcoalGrey">
              {t("yourRights.rightsLight11")}
              <a href="mailto:kole@smartcomply.com">kole@smartcomply.com</a>
            </p>
            <p className="text-sm md:text-[15px] text-CharcoalGrey">
              {t("yourRights.rightsLight12")} The Bunker Building 279 Herbert
              Macaulay Way, Yaba, Lagos, Nigeria.
            </p>
          </div>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            11. {t("retention.retentionBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("retention.retentionLight")}
          </p>
        </div>

        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            12. {t("cookie.cookieBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("cookie.cookieLight")}
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            13. {t("transfer.transferBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("transfer.transferLight1")}
          </p>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("transfer.transferLight2")}
          </p>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("transfer.transferLight3")}
          </p>
          <ul className="list-disc px-4 text-sm md:text-[15px] text-CharcoalGrey">
            <li className="mb-2"> {t("transfer.transferLight4")}</li>
            <li className="mb-2">{t("transfer.transferLight5")}</li>
            <li className="mb-2">{t("transfer.transferLight6")}</li>
            <li className="mb-2"> {t("transfer.transferLight7")}</li>
            <li className="mb-2">{t("transfer.transferLight8")}</li>
            <li className="mb-2">{t("transfer.transferLight9")}</li>
          </ul>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("transfer.transferLight10")}
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            14. {t("complaints.complaintsBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("complaints.complaintsLight1")}
          </p>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("complaints.complaintsLight2")}
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            15. {t("changes.chnagesBold")}
          </h4>

          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("changes.changesLight")}
          </p>
        </div>
        <div className="space-y-2">
          <h4 className="font-test-sohne-medium text-base md:text-xl text-opacity-60">
            {t("contactUs.contactUsBold")}
          </h4>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("contactUs.contsctUsLight1")}
          </p>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("contactUs.contsctUsLight2")}
          </p>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("contactUs.contsctUsLight4")}{" "}
            <a href="mailto:info@smartcomply.com">info@smartcomply.com</a>
          </p>
          <p className="text-sm md:text-[15px] text-CharcoalGrey">
            {t("contactUs.contsctUsLight3")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyBody;
